import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


// reset.css
import '@/assets/styles/react.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false

Vue.use(ElementUI)

//乱传
Vue.prototype.$bus = new Vue()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
